"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Online Training API
 * Online Training API documentation
 *
 * The version of the OpenAPI document: 0.0.81
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselAdministrationApi = exports.CarouselAdministrationApiFactory = exports.CarouselAdministrationApiFp = exports.CarouselAdministrationApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * CarouselAdministrationApi - axios parameter creator
 * @export
 */
const CarouselAdministrationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Operation Id: CreateCarouselImage - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Anasayfada bulunan carousele yeni bir resim ekler
         * @param {CreateCarouselImageForAdministrationCommand} [createCarouselImageForAdministrationCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCarouselImageForAdministration: (createCarouselImageForAdministrationCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/carousel_administration/create_carousel_image_for_administration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCarouselImageForAdministrationCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: DeleteCarouselImage - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Anasayfada bulunan carouselden resim siler
         * @param {DeleteCarouselImageForAdministrationCommand} [deleteCarouselImageForAdministrationCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCarouselImageForAdministration: (deleteCarouselImageForAdministrationCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/carousel_administration/delete_carousel_image_for_administration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteCarouselImageForAdministrationCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: GetCarouselImages - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Anasayfada bulunan carouselden resimleri getirir
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCarouselImagesForAdministration: (page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/carousel_administration/list_carousel_images_for_administration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: DeleteCarouselImage - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Anasayfada bulunan carousel resminin linkini değiştirir
         * @param {UpdateCarouselImageLinkForAdministrationCommand} [updateCarouselImageLinkForAdministrationCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarouselImageLinkForAdministration: (updateCarouselImageLinkForAdministrationCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/carousel_administration/update_carousel_image_link_for_administration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCarouselImageLinkForAdministrationCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: DeleteCarouselImage - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Anasayfada bulunan carousel resminin sırasını değiştirir
         * @param {UpdateCarouselImageOrderForAdministrationCommand} [updateCarouselImageOrderForAdministrationCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarouselImageOrderForAdministration: (updateCarouselImageOrderForAdministrationCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/carousel_administration/update_carousel_image_order_for_administration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCarouselImageOrderForAdministrationCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CarouselAdministrationApiAxiosParamCreator = CarouselAdministrationApiAxiosParamCreator;
/**
 * CarouselAdministrationApi - functional programming interface
 * @export
 */
const CarouselAdministrationApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CarouselAdministrationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Operation Id: CreateCarouselImage - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Anasayfada bulunan carousele yeni bir resim ekler
         * @param {CreateCarouselImageForAdministrationCommand} [createCarouselImageForAdministrationCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCarouselImageForAdministration(createCarouselImageForAdministrationCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createCarouselImageForAdministration(createCarouselImageForAdministrationCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: DeleteCarouselImage - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Anasayfada bulunan carouselden resim siler
         * @param {DeleteCarouselImageForAdministrationCommand} [deleteCarouselImageForAdministrationCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCarouselImageForAdministration(deleteCarouselImageForAdministrationCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteCarouselImageForAdministration(deleteCarouselImageForAdministrationCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: GetCarouselImages - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Anasayfada bulunan carouselden resimleri getirir
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCarouselImagesForAdministration(page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCarouselImagesForAdministration(page, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: DeleteCarouselImage - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Anasayfada bulunan carousel resminin linkini değiştirir
         * @param {UpdateCarouselImageLinkForAdministrationCommand} [updateCarouselImageLinkForAdministrationCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarouselImageLinkForAdministration(updateCarouselImageLinkForAdministrationCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCarouselImageLinkForAdministration(updateCarouselImageLinkForAdministrationCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: DeleteCarouselImage - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Anasayfada bulunan carousel resminin sırasını değiştirir
         * @param {UpdateCarouselImageOrderForAdministrationCommand} [updateCarouselImageOrderForAdministrationCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarouselImageOrderForAdministration(updateCarouselImageOrderForAdministrationCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCarouselImageOrderForAdministration(updateCarouselImageOrderForAdministrationCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.CarouselAdministrationApiFp = CarouselAdministrationApiFp;
/**
 * CarouselAdministrationApi - factory interface
 * @export
 */
const CarouselAdministrationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CarouselAdministrationApiFp)(configuration);
    return {
        /**
         * Operation Id: CreateCarouselImage - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Anasayfada bulunan carousele yeni bir resim ekler
         * @param {CreateCarouselImageForAdministrationCommand} [createCarouselImageForAdministrationCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCarouselImageForAdministration(createCarouselImageForAdministrationCommand, options) {
            return localVarFp.createCarouselImageForAdministration(createCarouselImageForAdministrationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: DeleteCarouselImage - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Anasayfada bulunan carouselden resim siler
         * @param {DeleteCarouselImageForAdministrationCommand} [deleteCarouselImageForAdministrationCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCarouselImageForAdministration(deleteCarouselImageForAdministrationCommand, options) {
            return localVarFp.deleteCarouselImageForAdministration(deleteCarouselImageForAdministrationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: GetCarouselImages - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Anasayfada bulunan carouselden resimleri getirir
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCarouselImagesForAdministration(page, options) {
            return localVarFp.listCarouselImagesForAdministration(page, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: DeleteCarouselImage - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Anasayfada bulunan carousel resminin linkini değiştirir
         * @param {UpdateCarouselImageLinkForAdministrationCommand} [updateCarouselImageLinkForAdministrationCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarouselImageLinkForAdministration(updateCarouselImageLinkForAdministrationCommand, options) {
            return localVarFp.updateCarouselImageLinkForAdministration(updateCarouselImageLinkForAdministrationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: DeleteCarouselImage - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Anasayfada bulunan carousel resminin sırasını değiştirir
         * @param {UpdateCarouselImageOrderForAdministrationCommand} [updateCarouselImageOrderForAdministrationCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarouselImageOrderForAdministration(updateCarouselImageOrderForAdministrationCommand, options) {
            return localVarFp.updateCarouselImageOrderForAdministration(updateCarouselImageOrderForAdministrationCommand, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CarouselAdministrationApiFactory = CarouselAdministrationApiFactory;
/**
 * CarouselAdministrationApi - object-oriented interface
 * @export
 * @class CarouselAdministrationApi
 * @extends {BaseAPI}
 */
class CarouselAdministrationApi extends base_1.BaseAPI {
    /**
     * Operation Id: CreateCarouselImage - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Anasayfada bulunan carousele yeni bir resim ekler
     * @param {CreateCarouselImageForAdministrationCommand} [createCarouselImageForAdministrationCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarouselAdministrationApi
     */
    createCarouselImageForAdministration(createCarouselImageForAdministrationCommand, options) {
        return (0, exports.CarouselAdministrationApiFp)(this.configuration).createCarouselImageForAdministration(createCarouselImageForAdministrationCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: DeleteCarouselImage - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Anasayfada bulunan carouselden resim siler
     * @param {DeleteCarouselImageForAdministrationCommand} [deleteCarouselImageForAdministrationCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarouselAdministrationApi
     */
    deleteCarouselImageForAdministration(deleteCarouselImageForAdministrationCommand, options) {
        return (0, exports.CarouselAdministrationApiFp)(this.configuration).deleteCarouselImageForAdministration(deleteCarouselImageForAdministrationCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: GetCarouselImages - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Anasayfada bulunan carouselden resimleri getirir
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarouselAdministrationApi
     */
    listCarouselImagesForAdministration(page, options) {
        return (0, exports.CarouselAdministrationApiFp)(this.configuration).listCarouselImagesForAdministration(page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: DeleteCarouselImage - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Anasayfada bulunan carousel resminin linkini değiştirir
     * @param {UpdateCarouselImageLinkForAdministrationCommand} [updateCarouselImageLinkForAdministrationCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarouselAdministrationApi
     */
    updateCarouselImageLinkForAdministration(updateCarouselImageLinkForAdministrationCommand, options) {
        return (0, exports.CarouselAdministrationApiFp)(this.configuration).updateCarouselImageLinkForAdministration(updateCarouselImageLinkForAdministrationCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: DeleteCarouselImage - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Anasayfada bulunan carousel resminin sırasını değiştirir
     * @param {UpdateCarouselImageOrderForAdministrationCommand} [updateCarouselImageOrderForAdministrationCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarouselAdministrationApi
     */
    updateCarouselImageOrderForAdministration(updateCarouselImageOrderForAdministrationCommand, options) {
        return (0, exports.CarouselAdministrationApiFp)(this.configuration).updateCarouselImageOrderForAdministration(updateCarouselImageOrderForAdministrationCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CarouselAdministrationApi = CarouselAdministrationApi;
